import { Component, Input } from "@angular/core"
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap"
import { NotificationsService } from "angular2-notifications"
import { UserService } from "../../../services/user.service"
import Utils from "../../../utils/utils"

@Component({
    selector: "app-join-roster-modal",
    templateUrl: "./join-roster-modal.component.html",
    styleUrls: ["./join-roster-modal.component.less"],
})
export class JoinRosterModalComponent {
    public student = ""
    @Input() public classInvitation = ""
    @Input() public rostercode = ""
    @Input() public classId = null

    constructor(
        public activeModal: NgbActiveModal,
        private userService: UserService,
        private notificationService: NotificationsService
    ) {}

    public joinClass() {
        this.userService.joinClass(this.classId, { display_name: this.student }).subscribe(
            (response) => {
                // TODO: better refresh
                window.location.href = "/student"
            },
            (error) => {
                this.handleError(error, "", "Could not add you to the class.")
            }
        )
    }

    private handleError(error, title, message) {
        title = title || "Uh oh!"
        message = message || ""
        if (error.error) {
            title = error.error.title || title
            message = error.error.body || message

            if (error.error.students) {
                // Specific error messages.
                const messages = error.error.students
                if (messages.roster) {
                    message = messages.roster
                } else if (messages.display_name) {
                    message = messages.display_name
                }
            }
        }
        this.notificationService.error(title, message, Utils.alertConfiguration)
    }
}
